import { faBell, faChevronRight, faInfoCircle, faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toolbar from "components/Toolbar";
import AuthContext from "context/AuthContext";
import useToastContext from "hooks/useToastContext";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiPut } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function Settings() {
  const { t } = useTranslation();
  let { user } = useContext(AuthContext);
  const [enableNotifications, setEnableNotifications] = useState(user.notifications);
  const notification = useToastContext();
  const navigate = useNavigate();

  const settings = [
    {
      title: t("NOTIFICATIONS"),
      icon: faBell,
      checkbox: true,
      onClick: async () => {
        var newValue = !enableNotifications;
        setEnableNotifications(newValue);
        try {
          var res = await apiPut(pathObj.notificationToggle, { status: newValue });
          if (res.data.success) {
            notification.success(res.data.message);
          } else {
            notification.error(res.data.message);
          }
        } catch (err) {}
      },
    },
    {
      title: t("SETTINGS_CHANGE_PASSWORD"),
      icon: faLock,
      checkbox: false,
      onClick: () => {
        navigate("/settings/reset-password");
      },
    },
    {
      title: t("TERMS_OF_USE"),
      icon: faInfoCircle,
      checkbox: false,
      onClick: () => {
        navigate("/terms-and-conditions");
      },
    },
    {
      title: t("REGISTER_PRIVACY_POLICY"),
      icon: faInfoCircle,
      checkbox: false,
      onClick: () => {
        navigate("/privacy-policy");
      },
    },
  ];

  return (
    <>
      <Toolbar title={t("NAV_SETTINGS")} showBackBtn={true} />
      <div className="flex flex-col w-full justify-center items-center">
        <div className="w-full md:w-[25rem] mt-3 p-4 overflow-y-auto">
          {settings.map((it) => (
            <div className="flex justify-between items-center border-b border-gray-200 dark:border-gray-700 p-4">
              <div className="flex justify-start items-center gap-2">
                <FontAwesomeIcon icon={it.icon} size={"lg"} />
                <span className="font-medium">{it.title}</span>
              </div>
              {it.checkbox ? (
                <>
                  <label className="inline-flex items-center cursor-pointer">
                    <input type="checkbox" checked={enableNotifications} className="sr-only peer" onClick={it.onClick} />
                    <div className="relative w-9 h-5 bg-neutral-quaternary peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-brand-soft dark:peer-focus:ring-brand-soft rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-buffer after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-[var(--primary)]"></div>
                  </label>
                </>
              ) : (
                <FontAwesomeIcon icon={faChevronRight} size={"lg"} className="cursor-pointer" onClick={it.onClick} />
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Settings;
